import React, { Component, useState, useEffect } from 'react'
import { connect } from "react-redux";
import Grid from "../../../components/grid";
import { getAllInventoryItems } from "../../../store/actions";
import AddOrder from "./item";
export const ItemView = (props) => {

  const { INVENTORY_ITEMS } = props;
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState("");

  const columnDefs = [
    {
      headerName: "Item Details",
      children: [{
        headerName: "Item Name",
        field: "clockItem.itemName",
        filter: false,
        width: 170,
      }, {
        headerName: "Serial #",
        field: "serialNumber",
        filter: false,
        width: 100,
      }]
    },
    {
      headerName: "Purchase Details",
      children: [
        {
          headerName: "Purchase Date",
          field: "purchaseDate",
          resizable: true,
          filter: false,
          valueFormatter: params => new Date(params.value).toLocaleDateString()
        },
        {
          headerName: "Order ID",
          field: "orderSystemId",
          resizable: true,
          filter: false,
        },
        {
          headerName: "Manufacturer Warranty Exp. Date",
          field: "vendorWarrantyEndDate",
          resizable: true,
          flex: 1,
          filter: false,
          valueFormatter: params => new Date(params.value).toLocaleDateString()
        },
      ]
    },

    {
      headerName: "Sale Details",
      children: [
        {
          headerName: "Sale Date",
          field: "saleDate",
          resizable: true,
          flex: 1,
          filter: false,
          valueFormatter: params => params.value ? new Date(params.value).toLocaleDateString() : ""
        },
        {
          headerName: "Client",
          field: "company.companyShortName",
          filter: false,
        },
        {
          headerName: "Initial Service Warranty Exp. Date",
          field: "serviceWarrantyEndDate",
          resizable: true,
          flex: 1,
          filter: false,
          valueFormatter: params => params.value ? new Date(params.value).toLocaleDateString() : ""
        },
        {
          headerName: "Billing Status",
          field: "orderStatus",
          resizable: true,
          flex: 1,
          filter: false,
        },
        {
          headerName: "Billing Date",
          field: "billingDate",
          resizable: true,
          flex: 1,
          filter: false,
          valueFormatter: params => params.value ? new Date(params.value).toLocaleDateString() : ""
        }
      ]
    },

  ];

  useEffect(() => {
    async function getAllItems() {
      await props.getAllInventoryItems();
      setRowData(INVENTORY_ITEMS);
    };
    getAllItems();
  }, []);

  function onGridReady(params) {
    params.api.addGlobalListener((type, e) => {
      if (type === "rowClicked") {
        openEdit(e.data);
      };
    });
  };
  function searchInput(e) {
    setSearchText(e.target.value)
  };

  function openEdit(event) {
    setShow(true);
    setIsEdit(true);
    setSelectedRowData(event)
  };

  function closeSideBar() {
    setShow(false);
    setIsEdit(false);
    setSelectedRowData("");
  };

  return (
    <>
      <div className="table-header d-flex align-items-center justify-content-between">
        {/* <button className="add_order" onClick={this.AddOrder}><img src={AddIcon} alt="" /> Add </button> */}
      </div>
      <div className="shadow_white_box full-box mt-0">
        <div className="filter-list d-flex align-items-center justify-content-between">
          <div className="filter-field d-flex">
            <input type="text" placeholder="Search" autoComplete="off" onChange={searchInput} />
          </div>
        </div>
        <div className="clients_grid">

          <Grid
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            rowData={rowData}
            height='600px'
          >
          </Grid>
        </div>
      </div>
      {show && (<AddOrder
        closeSidebar={closeSideBar}
        isEdit={isEdit}
        selectedRowData={selectedRowData} />)}
    </>
  )
};

const mapStateToProps = ({ UserReducer, InventoryItemsReducer, }) => {
  let { INVENTORY_ITEMS } = InventoryItemsReducer;
  return { UserReducer, INVENTORY_ITEMS, };
};
export default connect(mapStateToProps, { getAllInventoryItems })(ItemView);
